var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraOpenChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "13px",
    viewBox: "0 0 19 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCameraOpenChat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_OpenChat",
    transform: "translate(-323.000000, -36.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.586376,36.3756495 C341.494501,36.3418553 341.406154,36.3248871 341.32126,36.3248871 C341.13038,36.3248871 340.971511,36.3893451 340.84417,36.5179055 L336.571269,40.6008176 L336.571269,38.9250507 C336.571269,38.1192184 336.272619,37.4303853 335.675319,36.8581956 C335.077982,36.2860771 334.35895,36 333.517627,36 L326.053494,36 C325.212431,36 324.493176,36.2860771 323.895801,36.8581956 C323.29865,37.4303853 323,38.1192184 323,38.9250507 L323,46.075056 C323,46.8808172 323.29865,47.5696147 323.895839,48.1417688 C324.493213,48.7139229 325.212468,49 326.053531,49 L333.517701,49 C334.358987,49 335.078057,48.7139229 335.675394,48.1417688 C336.272694,47.5696147 336.571344,46.8808528 336.571344,46.075056 L336.571344,44.3890085 L340.844245,48.482059 C340.971585,48.6105838 341.130454,48.6750062 341.321334,48.6750062 C341.406228,48.6750062 341.494575,48.6580735 341.58645,48.6243505 C341.862262,48.5092011 342,48.3095305 342,48.025161 L342,36.9750169 C341.999889,36.6905051 341.86215,36.4907989 341.586376,36.3756495 Z",
    id: "icCameraOpenChat"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraOpenChat);
export default __webpack_public_path__ + "static/media/icCameraOpenChat.3feda69b35525b665ca0dcacdbc9926e.svg";
export { ForwardRef as ReactComponent };